import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import cn from 'classnames';
import { sstyled } from "./core/index.mjs";
import { forkRef } from "./ref.mjs";
export function callAllEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return !fns.some(function (fn) {
      var result;
      if (fn) {
        result = fn.apply(void 0, args);
      }
      return typeof result === 'boolean' && !result;
    });
  };
}
export function assignHandlers(props, source) {
  return Object.keys(source).reduce(function (proxySource, propName) {
    if (typeof source[propName] === 'function' && propName.startsWith('on')) {
      proxySource[propName] = callAllEventHandlers(props[propName], source[propName]);
    }
    return proxySource;
  }, {});
}
function assignHandlersInner(props, source) {
  return Object.keys(source).reduce(function (proxySource, propName) {
    if (propName !== 'ref' && propName.startsWith('on')) {
      if (typeof source[propName] === 'function' && typeof props[propName] === 'function') {
        proxySource[propName] = callAllEventHandlers(props[propName], source[propName]);
      } else if (typeof source[propName] === 'function') {
        proxySource[propName] = source[propName];
      } else if (typeof props[propName] === 'function') {
        proxySource[propName] = props[propName];
      }
    }
    return proxySource;
  }, {});
}
export default function assignProps() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // @ts-ignore
  if (props === source) return props;
  var newProps = _objectSpread(_objectSpread(_objectSpread({}, source), props), assignHandlersInner(props, source));
  for (var _key3 in source) {
    if (_key3.startsWith('use:')) {
      var originalKey = _key3.slice('use:'.length);
      newProps[originalKey] = source[_key3];
    }
  }
  for (var _key4 in props) {
    if (_key4.startsWith('use:')) {
      var _originalKey = _key4.slice('use:'.length);
      newProps[_originalKey] = props[_key4];
    }
  }

  // because react set getter for ref
  var sourceDescriptorRef = Object.getOwnPropertyDescriptor(source, 'ref');
  var propsDescriptorRef = Object.getOwnPropertyDescriptor(props, 'ref');
  if (sourceDescriptorRef !== null && sourceDescriptorRef !== void 0 && sourceDescriptorRef.configurable && propsDescriptorRef !== null && propsDescriptorRef !== void 0 && propsDescriptorRef.configurable) {
    newProps.ref = forkRef(source.ref, props.ref);
  }
  if (props.forwardRef) {
    newProps.ref = forkRef(newProps.ref, props.forwardRef);
    newProps.forwardRef = newProps.ref;
  }
  if (source.style && props.style) {
    newProps.style = _objectSpread(_objectSpread({}, source.style), props.style);
  }
  if (source.className) {
    newProps.className = cn(props.className, source.className);
  }
  if (source.styles && props.styles) {
    newProps.styles = sstyled.merge(source.styles, props.styles);
  }
  return newProps;
}
//# sourceMappingURL=assignProps.mjs.map